webpackJsonp([245],{

/***/ 1231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResumeAllDetail_vue__ = __webpack_require__(2965);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596bc1f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResumeAllDetail_vue__ = __webpack_require__(5369);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResumeAllDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596bc1f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResumeAllDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 2965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: this.$route.query.id,
      positionId: this.$route.query.position_id,
      form: {
        user_id: null,
        resume_id: null,
        name: null,
        gender: null,
        brithdate: null,
        address: null,
        domicile: null,
        height: null,
        education: null,
        photo: null,
        phone_number: null,
        working_experiences: [],
        working_experience_age: null,
        certificates: [],
        self_introduce: '', // 自我介绍
        expect_industry_type: null,
        expect_city_name: null,
        expect_salary_range: null,
        expect_time_period: null,
        expect_city_info: []
      },
      options: {
        genders: [],
        educations: [],
        cities: [],
        industries: [],
        salary_range: [],
        position: [],
        experience: [],
        certificates: [],
        expect_cities: [],
        working_experiences: [],
        working_experience_age: [],
        time_periods: [],
        working_experience_ages: []
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    var _this = this;

    request.all.page([request('getResumeOptions'), request('getResumeForm', this.id)]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          options = _ref2[0],
          form = _ref2[1];

      (function (data) {
        filter.setLoop(_this.options, data.data);
      })(options);(function (data) {
        filter.setLoop(_this.form, data.data);
      })(form);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getResumeForm', 'exportResumes', 'downloadResume', 'getResumeCity']), {
    onExport: function onExport() {
      var loadingInstance = __WEBPACK_IMPORTED_MODULE_2_element_ui__["Loading"].service({ fullscreen: true });

      request.common('exportResumes', { resume_ids: [this.form.resume_id] }).then(function (data) {
        loadingInstance.close();
        request.common('downloadResume', data.data.file);
      });
    }
  })
});

/***/ }),

/***/ 5369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("招聘管理")]),_vm._v(" "),_c('router-link',{attrs:{"to":'/users/detail/info?userid='+ _vm.form.user_id}},[_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title)+" userid="+_vm._s(_vm.form.user_id))])],1)],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"150px","size":"mini"}},[_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("基本信息")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"center"}},[(_vm.form.photo)?_c('a',{attrs:{"href":_vm.form.photo,"target":"_Blank"}},[_c('img',{staticStyle:{"border-radius":"50px"},attrs:{"src":_vm.form.photo+'?x-oss-process=image/resize,w_100/auto-orient,1',"width":"100px;","height":"100px;"}})]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('Br'),_vm._v(" "),_c('el-col',[_c('el-form-item',{attrs:{"label":"姓名:"}},[_vm._v(_vm._s(_vm.form.name))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"性别:"}},_vm._l((_vm.options.genders),function(item){return (item.id === _vm.form.gender)?_c('span',[_vm._v(_vm._s(item.text))]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"出生年月:"}},[_vm._v(_vm._s(_vm.form.brithdate))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在城市:"}},[_vm._v(_vm._s(_vm.form.address))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身高:"}},[_vm._v(_vm._s(_vm.form.height)+" cm")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"学历:"}},_vm._l((_vm.options.educations),function(item){return (item.id === _vm.form.education)?_c('span',[_vm._v(_vm._s(item.text))]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系电话:"}},[_vm._v(_vm._s(_vm.form.phone_number))])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("工作经验")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"从事过岗位:"}},_vm._l((_vm.form.working_experiences),function(working_experiences){return _c('span',[_vm._l((_vm.options.working_experiences),function(item){return (item.id === working_experiences.id && working_experiences.id !== 99)?_c('span',[_vm._v(_vm._s(item.text)+"    ")]):_vm._e()}),_vm._v(" "),(working_experiences.id === 99)?_c('span',[_vm._v(_vm._s(working_experiences.text))]):_vm._e()],2)}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作经验:"}},_vm._l((_vm.options.working_experience_ages),function(item){return (item.id === _vm.form.working_experience_age)?_c('span',[_vm._v(_vm._s(item.text))]):_vm._e()}),0)],1),_vm._v(" "),_c('Br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("求职意向")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作性质:"}},_vm._l((_vm.options.time_periods),function(item){return (item.id === _vm.form.expect_time_period)?_c('span',[_vm._v(_vm._s(item.text))]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"期望从事行业大类:"}},_vm._l((_vm.options.industries),function(item){return (item.id === _vm.form.expect_industry_type)?_c('span',[_vm._v(_vm._s(item.text))]):_vm._e()}),0),_vm._v(" "),_c('el-form-item',{attrs:{"label":"期望工作地点:"}},[(_vm.form.expect_city_info)?_c('span',[_vm._v(_vm._s(_vm.form.expect_city_info.city_name))]):_vm._e()]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"期望薪资:"}},_vm._l((_vm.options.salary_range),function(item){return (item.id === _vm.form.expect_salary_range)?_c('span',[_vm._v(_vm._s(item.text))]):_vm._e()}),0)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("技能/证书/证件")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"证件类别:"}},_vm._l((_vm.form.certificates),function(certificates){return _c('span',[_vm._l((_vm.options.certificates),function(item){return (item.id === certificates.id && certificates.id !== 99)?_c('span',[_vm._v(_vm._s(item.text)+"    ")]):_vm._e()}),_vm._v(" "),(certificates.id === 99)?_c('span',[_vm._v(_vm._s(certificates.text))]):_vm._e()],2)}),0)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("自我介绍")]),_vm._v(" "),_c('hr')]),_vm._v("\n        "+_vm._s(_vm.form.self_introduce)+"\n      ")],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-col',{attrs:{"span":8,"offset":6}},[_c('Br'),_c('br'),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onExport()}}},[_vm._v("下载简历\n        ")]),_vm._v("    \n\n        "),_c('router-link',{attrs:{"to":{path: '/resume/form/'+_vm.form.resume_id}}},[_c('el-button',[_vm._v("编辑")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":{path: '/resume/all_table'}}},[_c('el-button',[_vm._v("返回")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/245.f70418a4cfe02b70033a.js